// @ts-nocheck
import { bool, number, string } from 'prop-types'
import { type FC } from 'react'

import { InferPropsWithDefaults } from 'shared/utils/propTypes'
import { Img, Picture, Source } from 'views/components/atoms/ResponsiveImage'
import { sizesPropType } from 'views/utils/propTypes'
import { usePublicConfig } from 'views/utils/shopAndRuntimeConfigUtils'

import {
  generateSrcSet,
  generateWebPSrcSet,
  normaliseFileName,
} from './helpers'

const CdnImagePropTypes = {
  wrapperClassName: string,
  imgClassName: string,
  alt: string.isRequired,
  sizes: sizesPropType.isRequired,
  minWidth: number.isRequired,
  maxWidth: number.isRequired,
  maxHeight: number.isRequired,
  fileName: string.isRequired,
  lazyLoad: bool,
  preconnect: bool,
}

const CdnImageDefaultProps = {
  wrapperClassName: null,
  imgClassName: null,
  lazyLoad: false,
  preconnect: false,
}

type CdnImageProps = InferPropsWithDefaults<
  typeof CdnImagePropTypes,
  typeof CdnImageDefaultProps
>

const CdnImage: FC<CdnImageProps> = ({
  wrapperClassName,
  imgClassName,
  alt,
  sizes,
  fileName,
  lazyLoad,
  preconnect,
  minWidth,
  maxWidth,
  maxHeight,
  ...otherProps
}) => {
  const { cdnUrl } = usePublicConfig()

  const normalisedFileName = normaliseFileName(cdnUrl, fileName)

  const srcSet = generateSrcSet(cdnUrl, normalisedFileName, {
    minWidth,
    maxWidth,
  })
  const webpSrcSet = generateWebPSrcSet(srcSet)

  return (
    <Picture className={wrapperClassName}>
      <Source type="image/webp" sizes={sizes} srcSet={webpSrcSet} />
      <Img
        className={imgClassName}
        alt={alt}
        width={maxWidth}
        height={maxHeight}
        sizes={sizes}
        srcSet={srcSet}
        lazyLoad={lazyLoad}
        preconnect={preconnect}
        {...otherProps}
      />
    </Picture>
  )
}

CdnImage.propTypes = CdnImagePropTypes
CdnImage.defaultProps = CdnImageDefaultProps

export default CdnImage
